<div class="container">
  <h3 class="card-title">{{titulo}}</h3>
  <div class="row">
      <div class="form-group col-sm">
        <label for="mesDesde">Mes desde</label>
            <select
              #mesessd="ngModel"
              [(ngModel)]="mesSelectedDesde"
              name="mesDesde"
              id="mesDesde"
              class="form-control"
              required
            >
              <option *ngFor="let c of meses.list" [value]="c.id">
              {{ c.descripcion }}
              </option>
            </select>
            <div
              class="alert alert-danger"
              *ngIf="mesessd.touched && mesessd.invalid"
            >
              Mes es requerido
            </div>

        <!-- <mat-form-field>
          <mat-select  #mesessd="ngModel" placeholder="Mes desde"  [(ngModel)]="mesSelectedDesde" name="mesSelectedDesde" id="mesSelectedDesde">
            <mat-option  *ngFor="let c of meses.list" [value]="c.id"> {{ c.descripcion}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <small class="text-danger font-14"  *ngIf="mesessd.touched && mesessd.invalid">  Mes es requerido</small> -->
    </div>
    <div class="form-group col-sm">
      <label for="anioSelectedDesde">Año desde</label>
            <select
              #aniossd="ngModel"
              [(ngModel)]="anioSelectedDesde"
              name="anioSelectedDesde"
              id="anioSelectedDesde"
              class="form-control"
              required
            >
              <option *ngFor="let c of anios.list" [value]="c.id">
              {{ c.descripcion }}
              </option>
            </select>
            <div
              class="alert alert-danger"
              *ngIf="aniossd.touched && aniossd.invalid"
            >
              Año desde es requerido
            </div>

      <!-- <mat-form-field>
        <mat-select   placeholder="Año desde" #aniossd="ngModel" [(ngModel)]="anioSelectedDesde" name="anioSelectedDesde" id="anioSelectedDesde">
          <mat-option  *ngFor="let c of anios.list" [value]="c.id"> {{ c.descripcion}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <small class="text-danger font-14"  *ngIf="aniossd.touched && aniossd.invalid">  Año es requerido</small> -->
    </div>
  </div>
  <div class="row">
    <div class="form-group col-sm">
      <label for="mesSelectedHasta">Mes desde</label>
            <select
              #mesessh="ngModel"
              [(ngModel)]="mesSelectedHasta"
              name="mesSelectedHasta"
              id="mesSelectedHasta"
              class="form-control"
              required
            >
              <option *ngFor="let c of meses.list" [value]="c.id">
              {{ c.descripcion }}
              </option>
            </select>
            <div
              class="alert alert-danger"
              *ngIf="mesessh.touched && mesessh.invalid"
            >
              Mes es requerido
            </div>

      <!-- <mat-form-field>
        <mat-select  placeholder="Mes hasta" #mesessh="ngModel" [(ngModel)]="mesSelectedHasta" name="mesSelectedHasta" id="mesSelectedHasta" >
          <mat-option  *ngFor="let c of meses.list" [value]="c.id"> {{ c.descripcion}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <small class="text-danger font-14"  *ngIf="mesessh.touched && mesessh.invalid">  Mes es requerido</small> -->
      </div>
    <div class="form-group col-sm">
      <label for="anioSelectedHasta">Año hasta</label>
            <select
              #aniossh="ngModel"
              [(ngModel)]="anioSelectedHasta"
              name="anioSelectedHasta"
              id="anioSelectedHasta"
              class="form-control"
              required
            >
              <option *ngFor="let c of anios.list" [value]="c.id">
              {{ c.descripcion }}
              </option>
            </select>
            <div
              class="alert alert-danger"
              *ngIf="aniossh.touched && aniossh.invalid"
            >
              Año hasta es requerido
            </div>

      <!-- <mat-form-field>
        <mat-select placeholder="Año hasta" #aniossh="ngModel" [(ngModel)]="anioSelectedHasta" name="anioSelectedHasta" id="anioSelectedHasta">
          <mat-option  *ngFor="let c of anios.list" [value]="c.id"> {{ c.descripcion}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <small class="text-danger font-14"  *ngIf="aniossh.touched && aniossh.invalid">  Año es requerido</small> -->
    </div>
  </div>
  <div class="row pull-right" >
    <div class="action-buttons">
      <button type="button" class="btn btn-success mr-2" (click)="aceptar()">
        Aceptar
      </button>
      <button type="button" class="btn btn-warning" (click)="cancelar()">
        Cancelar
      </button>
    </div>
  </div>

</div>
